export default __webpack_public_path__ + "static/media/slider2-img-2.193ecea3.svg";